import axios from "axios";

// Empty/undefined -> use a relative "/api" path (same-origin, ideal for the
// combined DigitalOcean app). For split local dev, set REACT_APP_BACKEND_URL
// to the backend origin, e.g. http://localhost:8001.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const joinWaitlist = (data) => axios.post(`${API}/waitlist`, data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
